import escapeStringRegexp from 'escape-string-regexp';
// eslint-disable-next-line max-len
// Below functions copied from https://github.com/react-native-webview/react-native-webview/blob/74872a1f02c43e425f19739b1b25f5fbe614ba1f/src/WebViewShared.tsx#L10-L31
// as workaround until this PR can be merged: https://github.com/react-native-webview/react-native-webview/pull/1513
const extractOrigin = (url) => {
    const result = /^[A-Za-z][A-Za-z0-9+\-.]+:(\/\/)?[^/]*/.exec(url);
    return result === null ? '' : result[0];
};
const originAllowListToRegex = (originAllowList) => (`^${escapeStringRegexp(originAllowList).replace(/\\\*/g, '.*')}`);
const compileAllowList = (originAllowList) => (['about:blank', ...(originAllowList || [])].map(originAllowListToRegex));
export default function isUriAllowed({ uri, uriAllowList }) {
    const origin = extractOrigin(uri);
    return compileAllowList(uriAllowList).some((x) => new RegExp(x).test(origin));
}
//# sourceMappingURL=UriAllowList.js.map